import timeOffInputStore from "../store/store";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_END_TIME', function setEndTimeInStore(endTime: Moment) {
    timeOffInputStore.endTime = endTime.clone();
});
